import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tryout-past-due',
  templateUrl: './tryout-past-due.component.html',
  styleUrls: ['./tryout-past-due.component.css']
})
export class TryoutPastDueComponent implements OnInit {

  @Input() PastDue: number;

  //@Output() filterProgramsEvent = new EventEmitter();
  //program_status = '';

  constructor() { }

  ngOnInit() {
  }

  //filterProgramListing(value) {
  //  this.program_status = value;
  //  //this.filterProgramsEvent.emit(this.program_status);
  //}
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-past-due/tryout-past-due.component.ts